import React, { Component } from 'react'
import { Button, Accordion, Panel, PanelGroup } from 'react-bootstrap'
import moment from 'moment'
import { Link } from 'react-router'
import { translate } from "react-translate"
import { DIST_URL } from '../../../../constants/api';

// These are ids for which we don't want to show the column of 'disponibilidad'
const DISPONIBILIDAD_BLACKLIST = [39621];

@translate("PropertyDetail")
export default class Columns extends Component{
  constructor(props) {
    super(props)
    this.state = {
      activeKey: 1,
      caret: {
      }
    }
    this._toggleCaret = this._toggleCaret.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  _toggleCaret (data) {
    let newState = {}
    if (this.state.caret[data] !== true) {
      newState[data] = true
    }
    this.setState({caret: newState})
  }

  _renderCategory (id, categories) {
    let category = categories.filter(function (c) {
      return parseInt(c.id) === id;
    });
    return category = (category.length > 0) ? category[0].name : ''
  }

  _renderUbication (id, ubications) {
    let ubication = ubications.filter(function (c) {
      return parseInt(c.id) === id;
    });
    return ubication = (ubication.length > 0) ? ubication[0].name : ''
  }

  _renderAntiqui (date) {
    var d = moment(date, "DD-MM-YYYY");
    let years = moment().diff(d, 'years', false)
    return years
  }

  handleChangeProperty(code) {
    this.props.reloadProperties(code)
  }

  clearOptions(options) {
    return options.filter((i) => i.value !== '---')
  }

  handleItemPrice(item, defaultPriceText) {
    let divisa_rental = item.rental_currency && item.rental_currency.name;
    let divisa_sale = item.sale_currency && item.sale_currency.name;
    let operation_type_name = item.operation_type && item.operation_type.name
    if (divisa_rental == 'Dolar') {
        divisa_rental = 'u$s';
    }
    if (divisa_sale == 'Dolar') {
        divisa_sale = 'u$s';
    }
    let amount = ( operation_type_name === 'Alquiler' || operation_type_name == "Alquiler temporario") ? divisa_rental + ' ' + (parseInt(item.rental_amount)).toLocaleString('de-DE') : divisa_sale + ' ' + (parseInt(item.sale_amount)).toLocaleString('de-DE')

    let price;

    if((item.category_type_id === 9 || !item.web_price) ||
        ((operation_type_name == 'Alquiler' || operation_type_name == "Alquiler temporario") && (item.rental_amount in [0, 1, null, undefined, ''])) ||
        ((operation_type_name == 'Venta' || operation_type_name == "Venta/Alquiler") && (item.sale_amount in [0, 1, null, undefined, '']))) {
        price = defaultPriceText;
    } else {
        price = amount;
    }

    return price
  }

  getFromCustomTags(names = [], customTags) {
    return customTags
    .filter(i => (i.group_name && names.includes(i.group_name.trim())))
    .map(i => ({
      name: this.props.t(i.group_name),
      value: i.public_name,
    }))
  }

  getFromExtraAttributes(extraAttributes) {
    return extraAttributes
    .filter(i => (!i.is_expenditure && !i.is_measure) && (i.value !== '-'))
    .map(i => ({
      name: this.props.t(i.name.trim()),
      value: i.value,
    }))
  }

  renderSibling(item, index, style, pisos) {
    const { t } = this.props
    let number
    if(pisos) {
      number = item.title.split('-').find(item => item.indexOf(pisos) != -1)
      if (number) {
        number = number.replace(pisos,' ').trim()
      } else {
        number = t('Unidad')
      }
    }
    let surface
    if (pisos === 'Piso') {
      surface = item.covered_area
    } else {
      surface = item.land_area ? item.land_area : item.total_area
    }
    return (
      <Link to={'/' + item.property_code} key={index} onClick={() => this.handleChangeProperty(item.property_code)}>
        <div className="table-info-row">
          <h3 className={style}>{number}</h3>
          <h3 className="big-column">{surface ? surface + ' m2.' : '-'} </h3>
          <h3 className="big-column">{this.handleItemPrice(item, t('Consultar_precio'))}</h3>
        </div>
      </Link>
    )
  }

  render() {

    const { property, categories, terrainUses, ubications, siblings, t } = this.props
    let amount = (property.operation_type.name === 'Alquiler') ? property.rental_currency.name + ' ' + (parseInt(property.rental_amount)).toLocaleString('de-DE'): property.sale_currency.name + ' ' + (parseInt(property.sale_amount)).toLocaleString('de-DE')
    let price = (property.category_type_id === 9 || property.web_price) ? t('Consultar_Precio') : amount

    let firstColumn = {title: '' , options: [], class: ''}
    let secondColumn = {title: '' , options: [], class: ''}
    let thirdColumn = {title: '' , options: [], class: ''}
    let fourthColumn = {title: '' , options: [], class: ''}

    let firstTitle = ""
    let firstData = ""
    let secondTitle = ""
    let secondData = ""
    let thirdTitle = ""
    let thirdData = ""
    let fourthTitle = ""
    let fourthData = ""
    let others = ""
    let siblingsnew = {pisos: '', class: '', style: ''}
    let custom_tags = []
    let extra_attributes = []

    switch (property.property_type.name) {
      case 'Departamento':
      case 'Casa' :
      case 'Quinta':
      case 'PH': //house, apartment
        firstTitle = {title: t('Caracteristicas_Principales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        firstData = [
          {value: (property.ambients) ? property.ambients : '', name: t('Ambientes')},
          {value: (property.bedrooms) ? property.bedrooms : '', name: t('Dormitorios')},
          {value: (property.suite) ? property.suite : '', name: t('Dormitorios_Suite')},
          {value: (property.bathrooms) ? property.bathrooms : '', name: t('Banios')},
          {value: (property.toilettes) ? property.toilettes : '', name: t('Toilettes')},
          {value: (property.disposition) ? property.disposition : '', name: t('Disposicion')},
          {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
          {value: (property.garages) ? property.garages : property.covered_garages ? 1 : 0, name: t("Cocheras")},
          {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
          {value: (property.total_expenses) ? property.total_expenses : 0, name: t("Gastos")},
          {value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
        ]
        firstColumn.title = firstTitle
        firstColumn.options = firstData
        firstColumn.class = "col-md-4 col-sm-6"

        secondTitle = {title: t('Superficie'), img: DIST_URL+'/assets/images/icon-surfaces.png' }
        secondData = []

        others = [
          {name: t('Sup_Total'), value: (property.total_area) ? (property.total_area + ' m2') : ''},
          {name: t('Sup_Cubierta'), value: (property.covered_area) ? (property.covered_area + ' m2') : ''},
          {name: t('Sup_Semi_Cubierta'), value: (property.semicovered_area) ? (property.semicovered_area + ' m2') : ''},
          {name: t('Sup_Libre'), value: (property.free_area) ? (property.free_area + ' m2') : ''},
          {name: t('Sup_Terreno'), value: (property.land_area) ? (property.land_area + ' m2') : ''},
        ]
        for (var i in others) {
          secondData.push(others[i])
        }
        for (var i in property.surface) {
          if (property.surface[i].value && property.surface[i].value != '-') {
            let data = {name: property.surface[i].name, value: (property.surface[i].value + ' m2')}
            secondData.push(data)
          }
        }
        secondColumn.title = secondTitle
        secondColumn.options = secondData
        secondColumn.class = "col-md-4 col-sm-6"

        thirdTitle = {title: t('Caracteristicas_Generales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        thirdData = [
          {value: (property.antiquity && property.antiquity != -1) ? (property.antiquity + t('Anios')) : '', name: t('Antiguedad')},
          {value: (property.style) ? property.style.name : '', name: t('Estilo')},
          {value: (property.luminary) ? property.luminary.name : '', name: t('Luminosidad')},
          {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
          {value: (property.dependece_type) ? property.dependece_type.name : '', name: t('Dependencia')},
          {value: (property. surveillance) ? property.surveillance.name : '', name: t('Vigilancia')},
          {value: (property.garages && property.garages > 0) ? property.garages : '', name: t('Cocheras')},
          {value: (property.covered_garages) ? 1 : '', name: t('Cocheras_Cubiertas')},
          {value: (property.garages_type) ? property.garages_type.name : '', name: t('Tipo_Cochera')},
          {value: (property.roof) ? property.roof.name : '', name: t('Tipo_Techo')},
          {value: (property.kitchen_state) ? property.kitchen_state.name : '', name: t('Estado_Cocina')},
          {value: (property.calefaction_type) ? property.calefaction_type.name : '', name: t('Tipo_Calefaccion')},
          {value: (property.refrigeration_type) ? property.refrigeration_type.name : '', name: t('Tipo_Refrigeracion')},
          {value: (property.hot_water) ? property.hot_water.name : '', name: t('Agua_Caliente')},
          {value: (property.gate) ? property.gate.name : '', name: t('Tipo_Porton')},
          {value: (property.unit_state) ? property.unit_state.name : '', name: t('Estado')},
          {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
          {value: (property.ubication) ? this._renderUbication(property.ubication, ubications) : '', name: t('Ubicacion')}
        ]
        custom_tags = this.getFromCustomTags([
          "Seguridad",
          "Estado Baño",
          "Estilo",
          "Fachada",
          "Techos",
          "Aberturas",
          "Pisos Cocina",
          "Pisos Comedor",
          "Pisos De Dormitorios",
          "Pisos De Living",
          "Tipo Cocina",
          "Vista",
          "Fachada",
          "Red Agua",
        ], property.custom_tags)
        thirdData = thirdData.concat(custom_tags)
        extra_attributes = this.getFromExtraAttributes(property.extra_attributes)
        thirdData = thirdData.concat(extra_attributes)
        thirdColumn.title = thirdTitle
        thirdColumn.options = thirdData
        thirdColumn.class = "col-md-4 col-sm-6"

        fourthTitle = {title: t('Gastos'), img: DIST_URL+'/assets/images/icon-expenses.png' }
        fourthData = []
        for (var i in property.expenses) {
          if (property.expenses[i].value && property.expenses[i].value != '$-') {
            let hasSymbol = property.expenses[i].value.indexOf('$') !== -1;
            let data = {name: property.expenses[i].name, value: `${hasSymbol ? '' : '$ '} ${property.expenses[i].value}`}
            fourthData.push(data)
          }
        }
        fourthColumn.title = fourthTitle
        fourthColumn.options = fourthData
        fourthColumn.class = "col-md-4 col-sm-6"

        siblingsnew = {pisos: 'Piso', class: 'col-md-4 col-sm-6', style: ''}

        break;

        case 'Barrio Cerrado' : //barrio cerrado
          firstTitle = {title: t('Caracteristicas_Principales'), img: DIST_URL+'/assets/images/icon-generals.png' }
          firstData = [
            {value: (property.ambients) ? property.ambients : '', name: t('Ambientes')},
            {value: (property.bedrooms) ? property.bedrooms : '', name: t('Dormitorios')},
            {value: (property.suite) ? property.suite : '', name: t('Dormitorios_Suite')},
            {value: (property.bathrooms) ? property.bathrooms : '', name: t('Banios')},
            {value: (property.toilettes) ? property.toilettes : '', name: t('Toilettes')},
            {value: (property.disposition) ? property.disposition : '', name: t('Disposicion')},
            {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
            {value: (property.garages) ? property.garages : property.covered_garages ? 1 : 0, name: t("Cocheras")},
            {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
            {value: (property.total_expenses) ? property.total_expenses : 0, name: t("Gastos")},
            {value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
          ]
          firstColumn.title = firstTitle
          firstColumn.options = firstData
          firstColumn.class = "col-md-4 col-sm-6"

          secondTitle = {title: t('Superficie'), img: DIST_URL+'/assets/images/icon-surfaces.png' }
          secondData = []
          others = [
            {name: t('Sup_Total'), value: (property.total_area) ? (property.total_area + ' m2') : ''},
            {name: t('Sup_Cubierta'), value: (property.covered_area) ? (property.covered_area + ' m2') : ''},
            {name: t('Sup_Semi_Cubierta'), value: (property.semicovered_area) ? (property.semicovered_area + ' m2') : ''},
            {name: t('Sup_Libre'), value: (property.free_area) ? (property.free_area + ' m2') : ''},
            {name: t('Sup_Terreno'), value: (property.land_area) ? (property.land_area + ' m2') : ''},
          ]
          for (var i in others) {
            secondData.push(others[i])
          }
          for (var i in property.surface) {
            if (property.surface[i].value && property.surface[i].value != '-') {
              let data = {name: property.surface[i].name, value: (property.surface[i].value + ' m2')}
              secondData.push(data)
            }
          }
          
          secondColumn.title = secondTitle
          secondColumn.options = secondData
          secondColumn.class = "col-md-4 col-sm-6"

          thirdTitle = {title: t('Caracteristicas_Generales'), img: DIST_URL+'/assets/images/icon-generals.png' }
          thirdData = [
            {value: (property.antiquity && property.antiquity !== -1) ? (property.antiquity + t('Anios')) : (property.antiquity === -1) ? t('En_construccion') : '', name: t('Antiguedad')},
            {value: (property.style) ? property.style.name : '', name: t('Estilo')},
            {value: (property.luminary) ? property.luminary.name : '', name: t('Luminosidad')},
            {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
            {value: (property.dependece_type) ? property.dependece_type.name : '', name: t('Dependencia')},
            {value: (property. surveillance) ? property.surveillance.name : '', name: t('Vigilancia')},
            {value: (property.garages && property.garages > 0) ? property.garages : '', name: t('Cocheras')},
            {value: (property.covered_garages) ? 1 : '', name: t('Cocheras_Cubiertas')},
            {value: (property.garages_type) ? property.garages_type.name : '', name: t('Tipo_Cochera')},
            {value: (property.roof) ? property.roof.name : '', name: t('Tipo_Techo')},
            {value: (property.kitchen_state) ? property.kitchen_state.name : '', name: t('Estado_Cocina')},
            {value: (property.calefaction_type) ? property.calefaction_type.name : '', name: t('Tipo_Calefaccion')},
            {value: (property.refrigeration_type) ? property.refrigeration_type.name : '', name: t('Tipo_Refrigeracion')},
            {value: (property.hot_water) ? property.hot_water.name : '', name: t('Agua_Caliente')},
            {value: (property.gate) ? property.gate.name : '', name: t('Tipo_Porton')},
            {value: (property.unit_state) ? property.unit_state.name : '', name: t('Estado')},
            {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
            {value: (property.ubication) ? this._renderUbication(property.ubication, ubications) : '', name: t('Ubicacion')}
          ]
          custom_tags = this.getFromCustomTags([
            "Seguridad",
            "Estado Baño",
            "Estilo",
            "Fachada",
            "Techos",
            "Aberturas",
            "Pisos Cocina",
            "Pisos Comedor",
            "Pisos De Dormitorios",
            "Pisos De Living",
            "Tipo Cocina",
            "Vista",
            "Fachada",
            "Red Agua",
          ], property.custom_tags)
          thirdData = thirdData.concat(custom_tags)
          extra_attributes = this.getFromExtraAttributes(property.extra_attributes)
          thirdData = thirdData.concat(extra_attributes)
          thirdColumn.title = thirdTitle
          thirdColumn.options = thirdData
          thirdColumn.class = "col-md-4 col-sm-6"

          fourthTitle = {title: t('Gastos'), img: DIST_URL+'/assets/images/icon-expenses.png' }
          fourthData = []
          for (var i in property.expenses) {
            if (property.expenses[i].value && property.expenses[i].value != '$-') {
              let data = {name: property.expenses[i].name, value: property.expenses[i].value}
              fourthData.push(data)
            }
          }
          fourthColumn.title = fourthTitle
          fourthColumn.options = fourthData
          fourthColumn.class = "col-md-4 col-sm-6"

          siblingsnew = {pisos: 'Lote', class: 'col-md-6 col-sm-6', style: 'big-column'}

          break;

      case "Terreno":
      case "Nave Industrial":
      case "Depósito":
      case "Galpón": //industry
        firstTitle = {title: t('Caracteristicas_Principales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        firstData = [
          {value: (property.naves && property.naves > 0) ? property.naves : '', name: t('Cant_Naves')},
          {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
          {value: (property.bedrooms) ? property.bedrooms : '', name: t('Dormitorios')},
          {value: (property.bathrooms && property.bathrooms > 0) ? property.bathrooms : '', name: t('Banios')},
          {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
          {value: (property.garages && property.garages > 0) ? property.garages : '', name: t('Cocheras')},
          {value: (property.disposition) ? property.disposition : '', name: t('Disposicion')},
          {value: (property.zonification) ? property.zonification : '', name: t('Zonificacion')},
          {value: (property.unit_state) ? property.unit_state.name : '', name: t('Estado')},
          {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
          {value: (property.total_expenses) ? property.total_expenses : 0, name: t("Gastos")},
        ]
        firstColumn.title = firstTitle
        firstColumn.options = firstData
        firstColumn.class = "col-md-4 col-sm-6"

        secondTitle = {title: t('Superficie'), img: DIST_URL+'/assets/images/icon-surfaces.png' }
        secondData = []
        others = [
          {name: t('Sup_Total'), value: (property.total_area) ? (property.total_area + ' m2') : ''},
          {name: t('Sup_Cubierta'), value: (property.covered_area) ? (property.covered_area + ' m2') : ''},
          {name: t('Sup_Semi_Cubierta'), value: (property.semicovered_area) ? (property.semicovered_area + ' m2') : ''},
          {name: t('Sup_Libre'), value: (property.free_area) ? (property.free_area + ' m2') : ''},
          {name: t('Sup_Terreno'), value: (property.land_area) ? (property.land_area + ' m2') : ''},
        ]
        for (var i in others) {
          secondData.push(others[i])
        }
        for (var i in property.surface) {
          if (property.surface[i].value && property.surface[i].value != '-') {
            let data = {name: property.surface[i].name, value: (property.surface[i].value + ' m2')}
            secondData.push(data)
          }
        }
        secondColumn.title = secondTitle
        secondColumn.options = secondData
        secondColumn.class = "col-md-4 col-sm-6"

        thirdTitle = {title: t('Caracteristicas_Generales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        thirdData = []
        others = [{value: (property.antiquity && property.antiquity != -1) ? (property.antiquity + t('Anios')) : '', name: t('Antiguedad')},
                    {value: (property.floors && property.floors > 0) ? property.floors : '', name: t('Pisos')},
                    {value: (property.docks && property.docks > 0) ? property.docks : '', name: t('Docks')},
                    {value: (property.lift_trucks) ? property.lift_trucks : '', name: t('Montacarga')},
                    {value: (property.bridge_cranes) ? property.bridge_cranes : '', name: t('Puente_Gruas')},
                    {value: (property.bridge_cranes_capacity) ? property.bridge_cranes_capacity : '', name: t('Capacidad')},
                    {value: (property.prime_mover) ? '  ' : '', name: t('Fuerza_Motriz')},
                    {value: (property.genset) ? '  ' : '', name: t('Grupo_Electrogeno')},
                    {value: (property.water_tanks) ? property.water_tanks : '', name: t('Tanques_Agua')},
                    {value: (property.weighing_machines) ? property.weighing_machines : '', name: t('Balanzas')},
                    {value: (property.sewer) ? property.sewer.name : '', name: t('Red_Cloacal')},
                    {value: (property.water_network_type) ? property.water_network_type.name : '', name: t('Red_Agua')},
                    {value: (property.gas_network) ? property.gas_network.name : '', name: t('Red_Gas')},
                    {value: (property.air_space) ? property.air_space : '', name: t('Aire_Comprimido')},
                    {value: (property.unit_state) ? property.unit_state.name : '', name: t('Estado')},
                    {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
                    {value: (property.fire_system) ? property.fire_system.name : '', name: t('Sistema_Incendio')},]
        for (var i in others) {
          thirdData.push(others[i])
        }
        for (var i in property.generals) {
          if (property.generals[i].value === true){
            let data = {name: property.generals[i].name, value: ''}
            thirdData.push(data)
          }
        }
        custom_tags = this.getFromCustomTags([
          'Aire Comprimido',
          'Luminosidad',
          'Tipo Acceso',
          'Docks',
          'Fuerza Motriz',
        ], property.custom_tags)
        thirdData = thirdData.concat(custom_tags)
        extra_attributes = this.getFromExtraAttributes(property.extra_attributes)
        thirdData = thirdData.concat(extra_attributes)
        thirdColumn.title = thirdTitle
        thirdColumn.options = thirdData
        thirdColumn.class = "col-md-4 col-sm-6"
        fourthTitle = {title: t('Gastos'), img: DIST_URL+'/assets/images/icon-expenses.png' }
        fourthData = []
        for (var i in property.expenses) {
          if (property.expenses[i].value && property.expenses[i].value != '$-') {
            let data = {name: property.expenses[i].name, value: property.expenses[i].value}
            fourthData.push(data)
          }
        }
        fourthColumn.title = fourthTitle
        fourthColumn.options = fourthData
        fourthColumn.class = "col-md-4 col-sm-6"
        
        siblingsnew = {pisos: 'Lote', class: 'col-md-6 col-sm-6', style: 'big-column'}
        break;

      case "Chacra":
      case "Campo":
      case "Finca": //fields
        firstTitle = {title: t('Caracteristicas_Principales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        firstData = [
          {value: (property.suitability) ? property.suitability : '', name: t('Aptitud')},
          {value: (property.zonification) ? property.zonification : '', name: t('Zonificacion')},
          {value: (property.cattle_farming_type) ? property.cattle_farming_type.name : '', name: t('Tipo_Ganaderia')},
          {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
          {value: (property.unit_state) ? property.unit_state.name : '', name: t('Estado')},
          {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
        ]
        firstColumn.title = firstTitle
        firstColumn.options = firstData
        firstColumn.class = "col-md-4 col-sm-6"

        secondTitle = {title: t('Superficie'), img: DIST_URL+'/assets/images/icon-surfaces.png' }
        secondData = []
        others = [
          {name: t('Sup_Total'), value: (property.land_area) ? ((parseInt(property.land_area)/10000) + ' Ha') : ''},
        ]
        for (var i in others) {
          secondData.push(others[i])
        }
        for (var i in property.surface) {
          if (property.surface[i].value && property.surface[i].value != '-') {
            let data = {name: property.surface[i].name, value: (property.surface[i].value + ' m2')}
            secondData.push(data)
          }
        }
        secondColumn.title = secondTitle
        secondColumn.options = secondData
        secondColumn.class = "col-md-4 col-sm-6"

        thirdTitle = {title: t('Caracteristicas_Generales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        thirdData = []
        others =  [{value: (property.farming) ? property.farming : '', name: t('Agricola')},
                    {value: (property.cattle_farming) ? property.cattle_farming : '', name: t('Ganadero')},
                    {value: (property.receptivity) ? property.receptivity : '', name: t('Receptividad')},
                    {value: (property.breeding) ? property.breeding : '', name: t('Cria')},
                    {value: (property.re_breeding) ? property.re_breeding : '', name: t('Recria')},
                    {value: (property.wintering) ? property.wintering : '', name: t('Invernada')},
                    {value: (property.mills) ? property.mills : '', name: t('Cant_Molinos')},
                    {value: (property.pastures) ? property.pastures : '', name: t('Potreros')},
                    {value: (property.watery) ? property.watery : '', name: t('Aguadas')},
                    {value: (property.silos) ? property.silos : '', name: t('Silos')},
                    {value: (property.silos_capacity) ? property.silos_capacity : '', name: t('Capacidad_Balanza')},
                    {value: (property.perimeter_fence_state) ? property.perimeter_fence_state.name : '', name: t('Estado_del_alambrado_perimetral')},
                    {value: (property.internal_fence_state) ? property. internal_fence_state.name : '', name: t('Estado_del_alambrado_interno')},
                    {value: (property.energy_network) ? property.energy_network.name : '', name: t('Red_Electrica')},]
        for (var i in others) {
          thirdData.push(others[i])
        }
        for (var i in property.generals) {
          if (property.generals[i].value === "true"){
            let data = {name: property.generals[i].name, value: ''}
            thirdData.push(data)
          }
        }
        custom_tags = this.getFromCustomTags([
          'Tipo Ganadería',
          'Aptitud',
          'Regiones Geográficas',
          'Red De Gas',
          'Tipo Acceso',
        ], property.custom_tags)
        thirdData = thirdData.concat(custom_tags)
        extra_attributes = this.getFromExtraAttributes(property.extra_attributes)
        thirdData = thirdData.concat(extra_attributes)
        thirdColumn.title = thirdTitle
        thirdColumn.options = thirdData
        thirdColumn.class = "col-md-4 col-sm-6"

        fourthTitle = {title: t('Gastos'), img: DIST_URL+'/assets/images/icon-expenses.png' }
        fourthData = [
          {value: (property.total_expenses) ? property.total_expenses : 0, name: t("Gastos")},
        ]
        for (var i in property.expenses) {
          if (property.expenses[i].value && property.expenses[i].value != '$-') {
            let data = {name: property.expenses[i].name, value: property.expenses[i].value}
            fourthData.push(data)
          }
        }
        fourthColumn.title = fourthTitle
        fourthColumn.options = fourthData
        fourthColumn.class = "col-md-4 col-sm-6"

        break;

      case "Hotel" : //hotels
        firstTitle = {title: t('Caracteristicas_Principales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        firstData = [
          {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
          {value: (property.rooms && property.rooms > 0) ? property.rooms : '', name: t('Habitaciones')},
          {value: (property.bedrooms) ? property.bedrooms : '', name: t('Dormitorios')},
          {value: (property.bathrooms && property.bathrooms > 0) ? property.bathrooms : '', name: t('Banios')},
          {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
          {value: (property.floors && property.floors > 0) ? property.floors : '', name: t('Pisos')},
          {value: (property.unit_state) ? property.unit_state.name : '', name: t('Estado')},
          {value: (property.disposition) ? property.disposition : '', name: t('Disposicion')},
          {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
          {value: (property.floor_units && property.floor_units > 0) ? property.floor_units : '', name: t('Unidades_Piso')},
          {value: (property.toilettes) ? property.toilettes : '', name: t('Toilettes')},
          {value: (property.elevators && property.elevators > 0) ? property.elevators : '', name: t('Cant_Ascensores')},
          {value: (property.garages && property.garages > 0) ? property.garages : '', name: t('Cocheras')},
          {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
          {value: (property.zonification) ? property.zonification : '', name: t('Zonificacion')},
          {value: (property.total_expenses) ? property.total_expenses : 0, name: t("Gastos")},
        ]
        firstColumn.title = firstTitle
        firstColumn.options = firstData
        firstColumn.class = "col-md-4 col-sm-6"

        secondTitle = {title: t('Superficie'), img: DIST_URL+'/assets/images/icon-surfaces.png' }
        secondData = []
        others = [
          {name: t('Sup_Total'), value: (property.total_area) ? (property.total_area + ' m2') : ''},
          {name: t('Sup_Cubierta'), value: (property.covered_area) ? (property.covered_area + ' m2') : ''},
          {name: t('Sup_Semi_Cubierta'), value: (property.semicovered_area) ? (property.semicovered_area + ' m2') : ''},
          {name: t('Sup_Libre'), value: (property.free_area) ? (property.free_area + ' m2') : ''},
          {name: t('Sup_Terreno'), value: (property.land_area) ? (property.land_area + ' m2') : ''},
        ]
        for (var i in others) {
          secondData.push(others[i])
        }
        for (var i in property.surface) {
          if (property.surface[i].value && property.surface[i].value != '-') {
            let data = {name: property.surface[i].name, value: (property.surface[i].value + ' m2')}
            secondData.push(data)
          }
        }
        secondColumn.title = secondTitle
        secondColumn.options = secondData
        secondColumn.class = "col-md-4 col-sm-6"

        thirdTitle = {title: t('Caracteristicas_Generales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        extra_attributes = this.getFromExtraAttributes(property.extra_attributes)
        thirdData = []
        for (var i in property.generals) {
          if (property.generals[i].value === "true"){
            let data = {name: property.generals[i].name, value: ''}
            thirdData.push(data)
          }
        }
        custom_tags = this.getFromCustomTags([
          'Calefacción',
          'Categoria Del Hotel',
          'Refrigeración',
          'Marcas Ascensor',
          'Tipo Acceso',
          'Sistema Incendio',
          'Red Cloacal',
          'Red Agua',
          'Red De Gas',
          'Tipo Cocina',
          'Seguridad',
          'Cantidad de Asensores',
          'Cantidad de Pisos',
          'Capacidad Asensores',
          'Unidades por Piso',
        ], property.custom_tags)
        thirdData = thirdData.concat(custom_tags, extra_attributes)
        thirdColumn.title = thirdTitle
        thirdColumn.options = thirdData
        thirdColumn.class = "col-md-4 col-sm-6"
        break;

      case "Local":
      case "Edificio Comercial":
      case "Fondo de Comercio": //retail
        firstTitle = {title: t('Caracteristicas_Principales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        firstData = [ //{value: (property.floor_type) ? property.floor_type.name : '', name: 'Tipo de planta'},
          {value: (property.zonification) ? property.zonification : '', name: t('Zonificacion')},
          {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
          {value: (property.disposition) ? property.disposition : '', name: t('Disposicion')},
          {value: (property.plants && property.plants > 0) ? property.plants : '', name: t('Cant_Plantas')},
          {value: (property.ambients) ? property.ambients : '', name: t('Ambientes')},
          {value: (property.total_expenses) ? property.total_expenses : 0, name: t("Gastos")},
          {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
        ]
        firstColumn.title = firstTitle
        firstColumn.options = firstData
        firstColumn.class = "col-md-4 col-sm-6"

        secondTitle = {title: t('Superficie'), img: DIST_URL+'/assets/images/icon-surfaces.png' }
        secondData = []
        others = [
          {name: t('Sup_Total'), value: (property.total_area) ? (property.total_area + ' m2') : ''},
          {name: t('Sup_Terreno'), value: (property.land_area) ? (property.land_area + ' m2') : ''},
          {name: t('Sup_Cubierta'), value: (property.covered_area) ? (property.covered_area + ' m2') : ''},
          {name: t('Sup_Semi_Cubierta'), value: (property.semicovered_area) ? (property.semicovered_area + ' m2') : ''},
          {name: t('Sup_Libre'), value: (property.free_area) ? (property.free_area + ' m2') : ''}
        ]
        for (var i in others) {
          secondData.push(others[i])
        }
        for (var i in property.surface) {
          if (property.surface[i].value && property.surface[i].value != '-') {
            let data = {name: property.surface[i].name, value: (property.surface[i].value + ' m2')}
            secondData.push(data)
          }
        }
        secondColumn.title = secondTitle
        secondColumn.options = secondData
        secondColumn.class = "col-md-4 col-sm-6"

        thirdTitle = {title: t('Caracteristicas_Generales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        thirdData = []
        others =  [{value: (property.garages && property.garages > 0) ? property.garages : '', name: t('Cocheras')},
                    {value: (property.covered_garages) ? 1 : '', name: t('Cocheras_Cubiertas')},
                    {value: (property.open_garages) ? 1 : '', name: t('Cocheras_Descubiertas')},
                    {value: (property.bathrooms && property.bathrooms > 0) ? property.bathrooms : '', name: t('Banios')},
                    {value: (property.luminary) ? property.luminary.name : '', name: t('Luminaria')},
                    {value: (property.unit_state) ? property.unit_state.name : '', name: t('Estado')},
                    {value: (property.fire_system) ? property.fire_system.name : '', name: t('Sistema_Incendio')},
                    {value: (property.commercial_focus) ? property.commercial_focus.name : '', name: t('Foco_Comercial')},
                    {value: (property.calefaction_type) ? property.calefaction_type.name : '', name: t('Tipo_Calefaccion')},
                    {value: (property.refrigeration_type) ? property.refrigeration_type.name : '', name: t('Tipo_Refrigeracion')},
                    {value: (property.max_fot) ? property.max_fot.name : '', name: t('Fot_Max')},
                    {value: (property.basic_fot) ? property.basic_fot : '', name: t('Fot_Min')},
                    {value: (property.corner === "true") ? "  " : '', name: t('Esquina')},
                    {value: (property.air_space === "true") ? "  " : '', name: t('Espacio_Aereo')}]
        for (var i in others) {
          thirdData.push(others[i])
        }
        for (var i in property.generals) {
          if (property.generals[i].value === "true"){
            let data = {name: property.generals[i].name, value: ''}
            thirdData.push(data)
          }
        }
        custom_tags = this.getFromCustomTags([
          'Circulación Peatonal',
          'Circulación Vehicular',
          'Vista',
          'Tipo De Planta',
          'Material Piso',
          'Red Agua',
          'Tipo Cocina',
          'Seguridad',
          'Gastos',
        ], property.custom_tags)
        thirdData = thirdData.concat(custom_tags)
        thirdColumn.title = thirdTitle
        thirdColumn.options = thirdData
        thirdColumn.class = "col-md-4 col-sm-6"

        fourthTitle = {title: t('Gastos'), img: DIST_URL+'/assets/images/icon-expenses.png' }
        fourthData = []
        for (var i in property.expenses) {
          if (property.expenses[i].value && property.expenses[i].value != '$-') {
            let data = {name: property.expenses[i].name, value: property.expenses[i].value}
            fourthData.push(data)
          }
        }
        fourthColumn.title = fourthTitle
        fourthColumn.options = fourthData
        fourthColumn.class = "col-md-4 col-sm-6"

        break;

      case "Oficina":
      case "Edificio Comercial": //office/buildings
      case "Edificio de oficinas":
        siblingsnew = {pisos: 'Piso', class: 'col-md-4 col-sm-6', style: ''}
        firstTitle = {title: t('Caracteristicas_Principales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        firstData = [{value: (property.category) ? (this._renderCategory(property.category, categories)) : '', name: t('Categoria')},
          {value: (property.floor_type) ? property.floor_type.name : '', name: t('Tipo_Planta')},
          {value: (property.bathrooms && property.bathrooms > 0) ? property.bathrooms : '', name: t('Banios')},
          {value: (property.garages && property.garages > 0) ? property.garages : '', name: t('Cocheras')},
          {value: (property.covered_garages) ? 1 : '', name: t('Cocheras_Cubiertas')},
          {value: (property.open_garages) ? 1 : '', name: t('Cocheras_Abiertas')},
          {value: (property.zone.name) ? property.zone.name : '', name: t('Zona')},
          {value: (property.orientation) ? property.orientation : '', name: t('Orientacion')},
          {value: (property.toilettes) ? property.toilettes : '', name: t('Toilettes')},
          {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
          {value: (property.total_expenses) ? property.total_expenses : 0, name: t("Gastos")},
        ]
        firstColumn.title = firstTitle
        firstColumn.options = firstData
        firstColumn.class = "col-md-4 col-sm-6"

        secondTitle = {title: t('Superficie'), img: DIST_URL+'/assets/images/icon-surfaces.png' }
        secondData = [
          {value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
          {name: t('Sup_Total'), value: (property.total_area) ? (property.total_area + ' m2') : ''},
          {name: t('Sup_Cubierta'), value: (property.covered_area) ? (property.covered_area + ' m2') : ''},
          {name: t('Sup_Semi_Cubierta'), value: (property.semicovered_area) ? (property.semicovered_area + ' m2') : ''},
          {name: t('Sup_Libre'), value: (property.free_area) ? (property.free_area + ' m2') : ''},
          {name: t('Sup_Terreno'), value: (property.land_area) ? (property.land_area + ' m2') : ''},
        ]
        for (var i in property.surface) {
          if (property.surface[i].value && property.surface[i].value != '-') {
            let data = {name: property.surface[i].name, value: (property.surface[i].value + ' m2')}
            secondData.push(data)
          }
        }
        secondColumn.title = secondTitle
        secondColumn.options = secondData
        secondColumn.class = "col-md-4 col-sm-6"

        thirdTitle = {title: t('Caracteristicas_Generales'), img: DIST_URL+'/assets/images/icon-generals.png' }
        thirdData = []
        custom_tags = this.getFromCustomTags([
          'Material Piso',
          'Sistema Incendio',
          'Foco Comercial',
          'Calefacción',
          'Refrigeración',
          'Tipo Cocina',
          'Seguridad',
        ], property.custom_tags)
        thirdData = thirdData.concat(custom_tags)
        others = [{name: t('Estado'), value: (property.unit_state) ? property.unit_state.name : ''},
                  {name: t('Paller'), value: (property.palier_type) ? property.palier_type.name : ''},
                  {name: t('Luminosidad'), value: (property.luminary) ? property.luminary.name : ''},
                  {name: t('Vista'), value: (property.view) ? property.view.name : ''},
                  {name: t('Ubicacion'), value: (property.ubication) ? this._renderUbication(property.ubication, ubications) : ''}]
        for (var i in others) {
          thirdData.push(others[i])
        }
        for (var i in property.generals) {
          if (property.generals[i].value === "true"){
            let data = {name: property.generals[i].name, value: ''}
            thirdData.push(data)
          }
        }
        thirdColumn.title = thirdTitle
        thirdColumn.options = thirdData
        thirdColumn.class = "col-md-4 col-sm-6"

        fourthTitle = {title: t('Gastos'), img: DIST_URL+'/assets/images/icon-expenses.png' }
        fourthData = []
        for (var i in property.expenses) {
          if (property.expenses[i].value && property.expenses[i].value != '$-') {
            let hasSymbol = property.expenses[i].value.indexOf('$') !== -1;
            let data = {name: property.expenses[i].name, value:  `${hasSymbol ? '' : '$ '}${property.expenses[i].value}`}
            fourthData.push(data)
          }
        }
        fourthColumn.title = fourthTitle
        fourthColumn.options = fourthData
        fourthColumn.class = "col-md-4 col-sm-6"
    }

    firstColumn.options = this.clearOptions(firstColumn.options)
    secondColumn.options = this.clearOptions(secondColumn.options)
    thirdColumn.options = this.clearOptions(thirdColumn.options)
    fourthColumn.options = this.clearOptions(fourthColumn.options)

    let columns = []
    columns.push(firstColumn, secondColumn, thirdColumn, fourthColumn)
		var ctrl;
		for (var i = 0; i < columns.length; i++) {
			ctrl = false;
			columns[i].options.map((item, index) => {
				if ( !(typeof item.value == 'undefined' || parseFloat(item.value) == 0.0 || (typeof item.value == 'string' && item.value.trim() == '')) ) {
					ctrl = true;
				}
			})
			if(!ctrl) columns[i].class = columns[i].class + " hidden";
		}

    var propertyFeatures = t("Propiedad_Caracteristicas");

    return (
      <div>
        <div className="details-container hidden-xs">
          { (firstColumn.options.length > 0) ? (
            <div className={firstColumn.class}>
              <div className="col-header">
                <img src={firstColumn.title.img} />
                <h2>{firstColumn.title.title}</h2>
              </div>
              <div className="caracteristics-column">
                {firstColumn.options.map((item, index) =>
                  ( !(typeof item.value == 'undefined' || parseFloat(item.value) == 0.0 || (typeof item.value == 'string' && item.value.trim() == '')) ) ? (
                    <div className="ambients-values first-col" key={index}>
                      <div className="col-md-6 col-sm-6">
                        <p>{item.name}</p>
                      </div>
                        <div className="col-md-6 col-sm-6">
                          <p>{item.value}</p>
                        </div>
                    </div>
                  ) : ''
                )}
              </div>
            </div>
          ) : ''
          }
          { (secondColumn.options.length > 0) ? (
            <div className={secondColumn.class}>
              <div className="col-header">
                <img src={secondColumn.title.img} />
                <h2>{secondColumn.title.title}</h2>
              </div>
              <div className="caracteristics-column">
                {secondColumn.options.map((item, index) =>
                  ( !(typeof item.value == 'undefined' || parseFloat(item.value) == 0.0 || (typeof item.value == 'string' && item.value.trim() == '')) ) ? (
                    <div className="ambients-values first-col" key={index}>
                      <div className="col-md-6 col-sm-6">
                        <p>{item.name}</p>
                      </div>
                        <div className="col-md-6 col-sm-6">
                          <p>{item.value}</p>
                        </div>
                    </div> ) : ''
                )}
              </div>
            </div>
          ) : ''
          }
          { (thirdColumn.options.length > 0) ? (
            <div className={thirdColumn.class}>
              <div className="col-header">
                <img src={thirdColumn.title.img} />
                <h2>{thirdColumn.title.title}</h2>
              </div>
              <div className="caracteristics-column">
                {thirdColumn.options.map((item, index) =>
                  ( !(typeof item.value == 'undefined' || parseFloat(item.value) == 0.0 || (typeof item.value == 'string' && item.value.trim() == '')) ) ? (
                    <div className="ambients-values first-col" key={index}>
                      <div className="col-md-6 col-sm-6">
                        <p>{item.name}</p>
                      </div>
                        <div className="col-md-6 col-sm-6">
                          <p>{item.value}</p>
                        </div>
                    </div>) : ''
                )}
              </div>
            </div>
          ) : ''
          }
          { (fourthColumn.options.length > 0) ? (
            <div className={fourthColumn.class}>
              <div className="col-header">
                <img src={fourthColumn.title.img} />
                <h2>{fourthColumn.title.title}</h2>
              </div>
              <div className="caracteristics-column">
                {fourthColumn.options.map((item, index) =>
                  (item.value !== '') ? (
                    <div className="ambients-values first-col" key={index}>
                      <div className="col-md-6 col-sm-6">
                        <p>{item.name}</p>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <p>{item.value}</p>
                      </div>
                    </div> ) : ''
                )}
              </div>
            </div>
          ) : ''
          }
          { !DISPONIBILIDAD_BLACKLIST.includes(property.developing_code) && (siblings.length > 0) ? (
            <div className={siblingsnew.class}>
              <div className="col-header">
                <img src={DIST_URL+'/assets/images/icon-disponibility.png'} />
                <h2>Disponibilidad</h2>
              </div>
              <div className="table-siblings">
                <div className="table-title-row">
                  <h2 className={siblingsnew.style}>{siblingsnew.pisos}</h2>
                  <h2 className="big-column">Superficie</h2>
                  <h2 className="big-column">Valor</h2>
                </div>
                {siblings.map((item, index) =>
                  this.renderSibling(item, index, siblingsnew.style, siblingsnew.pisos)
                )}
              </div>
            </div>
          ) : ''
          }
        </div>
        <PanelGroup
          className={'visible-xs panelgroup-details-container'}
          accordion
          activeKey={this.state.activeKey}
          onSelect={this.handleSelect}
        >
          <Panel eventKey="1">
            <Panel.Heading>
              <Panel.Title toggle>
                <h2><img src={ DIST_URL+'/assets/images/icon-generals.png' } style={{paddingRight: 10+'px'}}/>{ propertyFeatures }<span className={`caret ${this.state.caret.property && 'caret-up'}`}></span></h2>
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <div>
                <div className="table-info-row">
                  <p className="big-column">{property.observations}</p>
                </div>
              </div>
            </Panel.Body>
          </Panel>
          {columns.map((col, index) =>
            (col.options.length > 0 ) ? (
              <Panel eventKey={`${index + 2}`}>
                <Panel.Heading>
                  <Panel.Title toggle>
                    <h2><img src={col.title.img} style={{paddingRight: 10+'px'}}/>{col.title.title}<span className={`caret ${this.state.caret['main'+index] && 'caret-up'}`}></span></h2>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  {col.options.map((item, index) =>
                    ( !(typeof item.value == 'undefined' || parseFloat(item.value) == 0.0 || (typeof item.value == 'string' && item.value.trim() == '')) ) ? (
                      <div className="ambients-values col-xs-6" key={index}>
                        <h4>{item.name}</h4>
                        <div className="row-detail" >
                          <p className="detail-value">{item.value}</p>
                        </div>
                      </div>
                      ) : ''
                  )}
                </Panel.Body>
              </Panel>) : ''
          )}
          {!DISPONIBILIDAD_BLACKLIST.includes(property.developing_code) && (siblings.length > 0) ? (
            <Panel eventKey={`${columns.length + 3}`}>
              <Panel.Heading>
                <Panel.Title toogle>
                  <h2>Disponibilidad<span className={`caret ${this.state.caret['siblings'] && 'caret-up'}`}></span></h2>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                {siblings.map((item, index) =>
                  <div>
                    <div className="table-info-row">
                      <p>{item.floor}</p>
                      <p className="big-column">{item.covered_area} m2.</p>
                      <p className="big-column">{price}</p>
                      <div className="link-siblings">
                      <Link to={'/' + item.property_code} key={index} onClick={() => this.handleChangeProperty(item.property_code)}>
                        Ver
                      </Link>
                    </div>
                    </div>
                  </div>
                )}
              </Panel.Body>
            </Panel> ) : ''
          }
        </PanelGroup>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/caracteristicsColumns.js